$(function(){

	// $("#op").delay(1800).fadeOut(800);

	// $("#menuButton, #globalNav a").click( function(){
	// 	$("#globalNav").fadeToggle(300);
	// 	$("#menuButton").toggleClass("active");
	// });
	// $("#menuButton, #globalNav a").click( function(){
	// 	if (window.matchMedia("(max-width: 820px)").matches) {
	// 		$("#globalNav").fadeToggle(300);
	// 		$("#menuButton").toggleClass("active");
	// 	}
	// });
	// $(window).resize(function() {
	// 	$("#menuButton").removeClass("active");
	// 	if (window.matchMedia("(max-width: 820px)").matches) {
	// 		$("#globalNav").fadeOut(300);
	// 	} else {
	// 		$("#globalNav").fadeIn(300);
	// 	}
	// });

  // $(window).scroll(function (){
	// 	$(".anim, #photo .photoWrap > div").each(function(){
	// 		var imgPos = $(this).offset().top;
	// 		var scroll = $(window).scrollTop();

	// 		var windowHeight = $(window).height();
	// 		if (window.matchMedia("(max-width: 880px)").matches) {
	// 			var scrollHeight = windowHeight/5;
	// 		} else {
	// 			var scrollHeight = windowHeight/3;
	// 		}

	// 		if (scroll > imgPos - windowHeight + scrollHeight){
	// 			$(this).addClass("on");
	// 		} else {
	// 			$(this).removeClass("on");
	// 		}
	// 	});
	// });

  // $('.inner-link').on("click", function() {
	// 	var speed = 400;
	// 	var href= $(this).attr("href");
	// 	var target = $(href == "#" || href == "" ? 'html' : href);
	// 	var position = target.offset().top;
	// 	$('body,html').animate({scrollTop:position}, speed, 'swing');
	// 	return false;
	// });

  $(window).scroll(function (){
    var scroll = $(window).scrollTop();

    if (scroll > 60){
      $(".header-wrapper").addClass("on");
    } else {
      $(".header-wrapper").removeClass("on");
    }
	});

  $(".first_view-slider").slick({
    autoplay:true,//自動再生する
    autoplaySpeed: 2000,//自動再生するスピード 4秒
    speed: 1200,
    fade: false,//フェードする
    infinite:true,//無限にスライドする
    slidesToShow: 2, // 表示するスライドの数
    arrows: false, // 矢印の表示
    dots: false,//ドット部分を表示する
		centerMode: true,//スライドを中心に表示して、部分的に前後のスライドが見えるように設定
    centerPadding: "20%",//centerMode時に前後のスライドが見える幅（px or ％）（初期値：50px）
    pauseOnFocus: false,//フォーカスで一時停止
    pauseOnHover: false,//マウスホバーで一時停止
    pauseOnDotsHover: false,//ドットナビをマウスホバーで一時停止
    responsive: [{
      breakpoint: 821,
      settings: {
        slidesToShow: 1,
      }
    }]
  });

  // $('.first_view-slider').slick({
  //   autoplay: true,//自動的に動き出すか。初期値はfalse。
  //   infinite: true,//スライドをループさせるかどうか。初期値はtrue。
  //   slidesToShow: 3,//スライドを画面に3枚見せる
  //   slidesToScroll: 3,//1回のスクロールで3枚の写真を移動して見せる
  //   prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
  //   nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
  //   dots: true,//下部ドットナビゲーションの表示
  //   responsive: [
  //     {
  //       breakpoint: 769,//モニターの横幅が769px以下の見せ方
  //       settings: {
  //         slidesToShow: 2,//スライドを画面に2枚見せる
  //         slidesToScroll: 2,//1回のスクロールで2枚の写真を移動して見せる
  //       }
  //     },
  //     {
  //       breakpoint: 426,//モニターの横幅が426px以下の見せ方
  //       settings: {
  //         slidesToShow: 1,//スライドを画面に1枚見せる
  //         slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
  //       }
  //     }
  //   ]
  // });

  // アコーディオン
  // $("#about dt").on("click", function(){
	// 	$(this).toggleClass("open");
	// 	$(this).next("dd").slideToggle(300);
	// });

  // $(".modal").colorbox({
  //   rel:"modal", //このクラスをグループ化する
	// 	speed: 300,
	// 	next: "<span id=arrowNext></span>",
	// 	previous: "<span id=arrowPrev></span>",
	// 	inline: true, //隠しているhtmlタグをモーダルで表示する
	// 	maxWidth:"90%",
	// 	maxHeight:"80%",

  //   // 縦横比を保持して表示する場合
  //   width: "90%", // == ( window.innerWidth * 0.9 )
  //   height: ( window.innerWidth * 0.9 / 16 * 9 ), //縦横比を16：9で表示
  //   // ここまで

	// 	width:752,
	// 	height:680,
	// 	opacity: 0.9,
  //   returnFocus: false, //Colorboxが閉じた時にフォーカス
	// 	fixed: true //画面に固定する
	// });

  // $(window).scroll(function (){
  //   var scroll = $(window).scrollTop();
  //   var windowHeight = $(window).height();
  //   var footer = $("footer").innerHeight();
  //   var documentHeight = $(document).height();

  //   if (scroll > documentHeight - footer - windowHeight){
  //     $(".ecLink a").addClass("on");
  //   } else {
  //     $(".ecLink a").removeClass("on");
  //   }
	// });

});